/**
 * Minimal US footer email → Klaviyo list subscribe.
 */
(function () {
  'use strict';

  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function clearInvalid(input, consent, errorEl) {
    if (input) {
      input.removeAttribute('aria-invalid');
      input.removeAttribute('aria-describedby');
    }
    if (consent) {
      consent.removeAttribute('aria-invalid');
      consent.removeAttribute('aria-describedby');
    }
    if (errorEl) {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }
  }

  function showError(errorEl, control, message) {
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.hidden = false;
    if (control) {
      control.setAttribute('aria-invalid', 'true');
      if (errorEl.id) control.setAttribute('aria-describedby', errorEl.id);
      if (typeof control.focus === 'function') control.focus();
    }
  }

  function subscribe(root, email) {
    var key = root.getAttribute('data-klaviyo-key') || 'WAxDCj';
    var revision = root.getAttribute('data-klaviyo-revision') || '2026-04-15';
    var listId = root.getAttribute('data-klaviyo-list-id') || '';
    if (!listId) return Promise.reject(new Error('Signup is temporarily unavailable.'));

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: {
                  'Last Consent Form': 'Sidekick US footer signup',
                  Market: 'US'
                }
              }
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: listId } }
        }
      }
    };

    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: revision
      },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok && res.status !== 202) {
        return res.json().catch(function () { return {}; }).then(function () {
          throw new Error('Something went wrong. Please try again.');
        });
      }
    });
  }

  function wire(root) {
    if (root.dataset.usEmailWired === '1') return;
    root.dataset.usEmailWired = '1';

    var form = qs(root, '[data-us-footer-email-form]');
    var input = qs(root, '[data-us-footer-email-input]');
    var consent = qs(root, '[data-us-footer-email-consent]');
    var errorEl = qs(root, '[data-us-footer-email-error]');
    var statusEl = qs(root, '[data-us-footer-email-status]');
    var submit = qs(root, '[data-us-footer-email-submit]');
    var success = qs(root, '[data-us-footer-email-success]');
    var successMsg = qs(root, '[data-us-footer-email-success-msg]');
    if (!form || !input || !consent) return;

    function setSubmitting(isSubmitting) {
      form.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');
      if (submit) {
        if (!submit.dataset.idleLabel) submit.dataset.idleLabel = submit.textContent || 'Join the list';
        submit.toggleAttribute('disabled', isSubmitting);
        submit.textContent = isSubmitting ? 'Joining…' : submit.dataset.idleLabel;
      }
      if (statusEl) {
        statusEl.textContent = isSubmitting ? 'Joining the Sidekick email list…' : '';
        statusEl.hidden = !isSubmitting;
      }
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearInvalid(input, consent, errorEl);
      setSubmitting(false);

      var email = (input.value || '').trim();
      if (!email || (input.validity && !input.validity.valid)) {
        showError(errorEl, input, 'Please enter a valid email address.');
        return;
      }
      if (!consent.checked) {
        showError(errorEl, consent, 'Please tick the box if you’d like to join the list.');
        return;
      }

      setSubmitting(true);
      subscribe(root, email)
        .then(function () {
          setSubmitting(false);
          form.hidden = true;
          if (success) success.hidden = false;
          if (successMsg) {
            successMsg.textContent = 'You’re on the list. We’ll be in touch.';
            requestAnimationFrame(function () {
              if (typeof successMsg.focus === 'function') successMsg.focus();
            });
          }
        })
        .catch(function (err) {
          setSubmitting(false);
          showError(errorEl, null, (err && err.message) || 'Something went wrong. Please try again.');
          if (errorEl) {
            errorEl.setAttribute('tabindex', '-1');
            if (typeof errorEl.focus === 'function') errorEl.focus();
          }
        });
    });
  }

  function signupTarget() {
    var nodes = document.querySelectorAll('[data-join-the-list]');
    for (var i = 0; i < nodes.length; i += 1) {
      if (nodes[i].offsetParent !== null) return nodes[i];
    }
    return (
      nodes[0] ||
      document.getElementById('join-the-list') ||
      document.querySelector('[data-us-footer-email-form]') ||
      document.getElementById('footer-group')
    );
  }

  function focusSignup() {
    var target = signupTarget();
    if (!target) return;
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.scrollIntoView({
      block: 'start',
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
    window.requestAnimationFrame(function () {
      if (typeof target.focus === 'function') target.focus({ preventScroll: true });
    });
  }

  function isSignupHash(href) {
    if (!href) return false;
    try {
      var url = new URL(href, window.location.origin);
      return url.hash === '#join-the-list' || url.hash === '#footer-group';
    } catch (error) {
      return href === '#join-the-list' || href === '#footer-group';
    }
  }

  if (!window.__usFooterJoinFocusWired) {
    window.__usFooterJoinFocusWired = true;
    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href]');
      if (!link || !isSignupHash(link.getAttribute('href'))) return;
      if (signupTarget()) {
        event.preventDefault();
        focusSignup();
      }
    });

    if (location.hash === '#join-the-list' || location.hash === '#footer-group') {
      window.requestAnimationFrame(focusSignup);
    }
    window.addEventListener('hashchange', function () {
      if (location.hash === '#join-the-list' || location.hash === '#footer-group') {
        focusSignup();
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-us-footer-email]').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
